module.exports = __webpack_public_path__ + "media/images/Logo_Tavour_White/Logo_Tavour_White-eb62d47b1ad852e92d99a683bac217b2.png";